import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { mainMenuItems } from "./menuItems";
import { getNavigate } from "../helper/utility";
import '../assets/css/Sidebar.css';
import CustomTopbar from './CustomTopbar';

const SidebarLayout = () => {
  const navigate = getNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsOpen(window.innerWidth >= 1024);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleSubMenu = (key: string) =>
    setActiveMenu(activeMenu === key ? null : key);

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    if (window.innerWidth < 1024) {
      setIsOpen(false);
    }
    navigate(path);
  };

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <div className="sidebar-wrapper">
      <div className={`sidebar-header ${isOpen ? 'open' : ''}`} style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 1rem'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {isOpen && (<h2 style={{color:"var(--white-color)"}}>Hem - Admin</h2>)}
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            {isOpen ? <i className="fas fa-times all-small-icon" style={{color:"var(--white-color)"}}></i> : <i className="fas fa-bars all-small-icon" style={{color:"var(--white-color)"}}></i>}
          </button>
        </div>

        <CustomTopbar />

      </div>

      <div className={`custom-sidebar ${isOpen ? 'open' : ''}`}>
        <ul>
          {mainMenuItems.map((item, index) => (
            <li key={index}>
              {item.children ? (
                <div>
                  <div
                    onClick={() => toggleSubMenu(item.key || `menu-${index}`)}
                    className={`submenu-toggle ${activeMenu === item.key ? 'active-parent' : ''}`}
                  >
                    <span>{item.label}</span>
                    <span className={`submenu-arrow ${activeMenu === item.key ? 'open' : ''}`}>
                      {activeMenu === item.key ? <i className="fas fa-chevron-down all-small-icon" style={{color:"var(--white-color)"}}></i>
                        : <i className="fas fa-chevron-right all-small-icon" style={{color:"var(--white-color)"}}></i>
                      }
                    </span>
                  </div>
                  {activeMenu === item.key && (
                    <ul className="sub-menu">
                      {item.children.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <Link
                            to={''}
                            className={isActive(subItem.path || '') ? 'active' : ''}
                            onClick={(e) => handleLinkClick(e, subItem.path || '')}
                          >
                            {subItem.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ) : (
                <Link
                  to={''}
                  className={isActive(item.path || '') ? 'active' : ''}
                  onClick={(e) => handleLinkClick(e, item.path || '')}
                >
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SidebarLayout;
